import React from 'react';
import { IImageAsset } from '../../../../contentful';
import { QuickLink } from '../../../../components/common/quick-links/QuickLink';
import { QuickLinksColumn } from '../../../../components/common/quick-links/QuickLinksColumn';
import {
	PressReleaseSectionWrapper,
	StyledPressReleaseSectionHeader,
} from './PressReleasePage.styles';

interface IPressReleaseDownloadsSection {
	assets: IImageAsset[];
}

export default function PressReleaseDownloadsSection({
	assets,
}: IPressReleaseDownloadsSection) {
	return (
		<PressReleaseSectionWrapper>
			<StyledPressReleaseSectionHeader>
				Downloads
			</StyledPressReleaseSectionHeader>
			<QuickLinksColumn>
				{assets.map((asset) => {
					const { file, title } = asset.fields;
					return (
						<QuickLink
							key={asset.id}
							type="asset"
							url={file.url}
							ariaLabel={title}
						>
							{title}
						</QuickLink>
					);
				})}
			</QuickLinksColumn>
		</PressReleaseSectionWrapper>
	);
}
